/*
 *
 * Form actions
 *
 */

import {
  GET_COMPANIES_INFO_SUCCESS,
  GET_COMPANIES_INFO_WATCHER,
  GET_COMPANIES_SAVE_FAILED,
  GET_COMPANIES_SAVE_WATCHER,
  GET_COMPANIES_SAVE_SUCCESS,
  GET_COMPANY_SUCCESS,
  GET_COMPANY_WATCHER,
  DELETE_COMPANY_SUCCESS,
  DELETE_COMPANY_WATCHER,
  DELETE_COMPANY_FAILED,
  STATUS_COMPANY_WATCHER,
  USERS_COMPANY_FAILED,
  USERS_COMPANY_SUCCESS,
  USERS_COMPANY_WATCHER,
  USERS_SA_SWITCH_WATCHER,
  USERS_SA_SWITCH_SUCCESS,
  USERS_SA_SWITCH_FAILED,
  DELETE_USER_WATCHER,
  GET_USERS_WATCHER,
  GET_USERS_SUCCESS,
  VALIDATE_VISMA_PEOPLE_INFO_WATCHER,
  VALIDATE_VISMA_PEOPLE_INFO_SUCCESS,
  VALIDATE_VISMA_PEOPLE_INFO_FAILED,
  VALIDATE_VISMA_PEOPLE_STRUCTURE_WATCHER,
  VALIDATE_VISMA_PEOPLE_STRUCTURE_SUCCESS,
  VALIDATE_VISMA_PEOPLE_STRUCTURE_FAILED,
  UPDATE_VALIDATE_VISMA_PEOPLE_REQUESTED,
  UPDATE_VALIDATE_VISMA_PEOPLE_STRUCTURE_REQUESTED,
  RESET_COMPANIES_INFO,
  RESET_VISMA_PEOPLE_VALIDATIONS,
  RESET_VISMA_PEOPLE_STRUCTURE_VALIDATIONS,
} from "./constants"

export function getCompaniesInfoWatcher(payload) {
  return {
    type: GET_COMPANIES_INFO_WATCHER,
    payload,
  }
}

export function getCompaniesInfoSuccess(payload) {
  return {
    type: GET_COMPANIES_INFO_SUCCESS,
    payload,
  }
}

export function saveCompanyWatcher(payload) {
  return {
    type: GET_COMPANIES_SAVE_WATCHER,
    payload,
  }
}

export function saveCompanySuccess(payload) {
  return {
    type: GET_COMPANIES_SAVE_SUCCESS,
    payload,
  }
}

export function saveCompanyFailed(payload) {
  return {
    type: GET_COMPANIES_SAVE_FAILED,
    payload,
  }
}

export function getCompanyWatcher(payload) {
  return {
    type: GET_COMPANY_WATCHER,
    payload,
  }
}

export function getCompanySuccess(payload) {
  return {
    type: GET_COMPANY_SUCCESS,
    payload,
  }
}

export function deleteCompanyWatcher(payload) {
  return {
    type: DELETE_COMPANY_WATCHER,
    payload,
  }
}

export function deleteCompanySuccess(payload) {
  return {
    type: DELETE_COMPANY_SUCCESS,
    payload,
  }
}

export function deleteCompanyFailed(payload) {
  return {
    type: DELETE_COMPANY_FAILED,
    payload,
  }
}

export function statusCompanyWatcher(payload) {
  return {
    type: STATUS_COMPANY_WATCHER,
    payload,
  }
}

export function usersCompanyWatcher(payload) {
  return {
    type: USERS_COMPANY_WATCHER,
    payload,
  }
}

export function usersCompanySuccess(payload) {
  return {
    type: USERS_COMPANY_SUCCESS,
    payload,
  }
}

export function usersCompanyFailed(payload) {
  return {
    type: USERS_COMPANY_FAILED,
    payload,
  }
}

export function usersSASwitchWatcher(payload) {
  return {
    type: USERS_SA_SWITCH_WATCHER,
    payload,
  }
}

export function usersSASwitchSuccess(payload) {
  return {
    type: USERS_SA_SWITCH_SUCCESS,
    payload,
  }
}

export function usersSASwitchFailed(payload) {
  return {
    type: USERS_SA_SWITCH_FAILED,
    payload,
  }
}

export function deleteUserWatcher(payload) {
  return {
    type: DELETE_USER_WATCHER,
    payload,
  }
}
export function getCompanyUsersWatcher(payload) {
  return {
    type: GET_USERS_WATCHER,
    payload,
  }
}

export function getCompanyUsersSuccess(payload) {
  return {
    type: GET_USERS_SUCCESS,
    payload,
  }
}

export function validateVismaPeopleInfoWatcher (payload) {
  return {
    type: VALIDATE_VISMA_PEOPLE_INFO_WATCHER,
    payload,
  }
}

export function validateVismaPeopleInfoSuccess (payload) {
  return {
    type: VALIDATE_VISMA_PEOPLE_INFO_SUCCESS,
    payload,
  }
}

export function validateVismaPeopleInfoFailed (payload) {
  return {
    type: VALIDATE_VISMA_PEOPLE_INFO_FAILED,
    payload,
  }
}

export function validateVismaPeopleStructureWatcher (payload) {
  return {
    type: VALIDATE_VISMA_PEOPLE_STRUCTURE_WATCHER,
    payload,
  }
}

export function validateVismaPeopleStructureSuccess (payload) {
  return {
    type: VALIDATE_VISMA_PEOPLE_STRUCTURE_SUCCESS,
    payload,
  }
}

export function validateVismaPeopleStructureFailed (payload) {
  return {
    type: VALIDATE_VISMA_PEOPLE_INFO_FAILED,
    payload
  }
}

export function updateValidateVismaPeopleRequested (payload) {
  return {
    type: UPDATE_VALIDATE_VISMA_PEOPLE_REQUESTED,
    payload
  }
}

export function updateValidateVismaPeopleStructureRequested (payload) {
  return {
    type: UPDATE_VALIDATE_VISMA_PEOPLE_STRUCTURE_REQUESTED,
    payload
  }
}

export function resetCompaniesInfo (payload) {
  return {
    type: RESET_COMPANIES_INFO,
    payload
  }
}

export function resetVismaPeopleValidations(payload) {
  return {
    type: RESET_VISMA_PEOPLE_VALIDATIONS,
    payload
  }
}

export function resetVismaPeopleStructureValidations(payload) {
  return {
    type: RESET_VISMA_PEOPLE_STRUCTURE_VALIDATIONS,
    payload
  }
}